import { render, staticRenderFns } from "./v-ripple-col.vue?vue&type=template&id=029dc636&scoped=true"
import script from "./v-ripple-col.vue?vue&type=script&lang=js"
export * from "./v-ripple-col.vue?vue&type=script&lang=js"
import style0 from "./v-ripple-col.vue?vue&type=style&index=0&id=029dc636&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029dc636",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
